/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Typologie du bien — libellés dans form-rules/property-form.json (champ propertySizeType)
 */
export const propertySizeTypeCodeSchema = z.enum(["T1", "T1_BIS", "T2", "T2_BIS", "T3", "T4", "T5", "T6", "T7", "T8", "T9", "T10", "T10_PLUS"]).describe("Typologie du bien — libellés dans form-rules/property-form.json (champ propertySizeType)")